import AvField from 'availity-reactstrap-validation/lib/AvField';
import AvForm from 'availity-reactstrap-validation/lib/AvForm';
import dayjs from 'dayjs';
import React from 'react'
import ReactAudioPlayer from 'react-audio-player';
import ShowMoreText from 'react-show-more-text';
import { Button, ButtonDropdown, Card, CardBody, CardImg, Col, Container, CustomInput, FormGroup, Label, Row, Spinner } from 'reactstrap';
import useGet from '../../../../helpers/hooks/useGet';

const PostDetails = (props) => {

  const [post, postError, postLoading] = useGet(
    `/baithak-posts-admin/${props.match.params.id}?filter=${encodeURIComponent(
      JSON.stringify({
        include: [
          { relation: 'farmer' },
          { relation: 'postComments',
            scope:{
              include: [
                { relation: 'farmer' }
              ],
            } 
          }
        ],
      })
    )}`,
    true,
  ); 
  console.log(post)
    return (
        <>
         
      
        <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' >
            <Row>
            {postLoading ? (
          <div className='text-center w-100'>
            <Spinner className='mr-2' color='primary' />
          </div>
        ) : (
              <Col md={{ size: 8, offset: 2 }}>
                <h4 className='card-title'>Post Detail</h4>
                <Card>
                  <CardBody>
                      <>
                <div   className= 'd-flex' >
                  <div>
                      <img  style={{height:50, width: 50, borderRadius:"50%"}} src={post?.farmer?.profilePicture} className='avatar-md' />
                      </div>
                    <div  style={{marginLeft:'10px'}} >
                      <h3>{post?.farmer?.name}</h3>
                      <p  className='chat-time mb-0'>
                                <i className='mdi mdi-clock-outline align-middle mr-1'></i>{' '}
                                {dayjs(post?.createdAt).format(
                                  'DD/MM/YYYY HH:mm:ss'
                                )}
                              </p>
                              </div>
                 
                  </div>
                  <div>
                 {!post?.media ? (
                    <span style={{paddingLeft:'15px', paddingTop:'15px'}} className='w-25 d-block,'>
                     
                      <h6>{post?.post}</h6>  
                  
                    </span>
                  ) : post.media[0]?.type === 'AUDIO' ? (
                    <ReactAudioPlayer
                      src={post.media[0]?.url}
                      autoPlay={false}
                      controls
                      preload='auto'
                    />
                  ) : post.media[0]?.type === 'IMAGE' ? (
                    <img style={{maxHeight:'200px'}} src={post.media[0].url}  />
                  ) : (
                    <video
                      controls=''
                      width='233'
                      height='233'
                      autoplay={false}
                      name='media'
                    >
                      <source src={post.media[0].url} type='video/mp4' />
                    </video>
                  )}
                  </div>
                

                      {/* <img src={post?.media[0].url} stryle={{width:'100%', height: '100%'}} className='avatar-lg' /> */}

                      <div style={{paddingTop:'10px'}} >
                      <span>{post?.likes.length} Like</span>
                      <span style={{marginLeft: '.5rem'}}> {post?.postComments?.length}  Comments</span>
                      <span style={{marginLeft: '.5rem'}}>{post?.flags.length}  Flags</span>
                      </div>
                      <br/>
                      <h4>Comments</h4>
                      {post?.postComments?.map((posts,id)=>(
                         <Card key={id}>
                         <CardBody style={{backgroundColor:'#eff2f7'}}>
                           
                                   <div   className= 'd-flex' >
                  <div>
                      <img  style={{height:50, width: 50, borderRadius:"50%"}} src={posts?.farmer?.profilePicture} className='avatar-md' />
                      </div>
                    <div  style={{marginLeft:'10px'}} >
                      <h6>{posts?.farmer?.name}</h6>
                      <p  className='chat-time mb-0'>
                                <i className='mdi mdi-clock-outline align-middle mr-1'></i>{' '}
                                {dayjs(posts?.createdAt).format(
                                  'DD/MM/YYYY HH:mm:ss'
                                )}
                              </p>
                              </div>
                 
                  </div>
                  <div> 
                 {posts.contentType === 'TEXT' ? (
                    <span style={{paddingLeft:'15px', paddingBottom:'15px'}} className='w-25 d-block,'>
                     
                      <p >{posts.content}</p>  
                  
                    </span>
                  ) : posts.contentType === 'AUDIO' ? (
                    <ReactAudioPlayer
                      src={posts.content}
                      autoPlay={false}
                      controls
                      preload='auto'
                    />
                  ) : posts.contentType === 'IMAGE' ? (
                    <img style={{maxHeight:'200px',minHeight:'200px', maxWidth:'700px'}} src={posts.content}  />
                  ) : (
                    <video
                      controls=''
                      width='233'
                      height='233'
                      autoplay={false}
                      name='media'
                    >
                      <source src={posts.content} type='video/mp4' />
                    </video>
                  )}
                  </div>
                         </CardBody>
                         </Card>
                      ))}
                     
               
                            
                            </>
                  </CardBody>
                  </Card>
                  </Col>
        )}
                  </Row>
          </AvForm>
        </Container>
      </div>
    </>
    )
}

export default PostDetails;
